import React from 'react';
import { JavvyFeatures } from './components/JavvyFeatures';
export function App() {
  return <JavvyFeatures data-id="element-0" />;
}